module.exports = __webpack_public_path__ + "static/media/model-pajero-06-lwb.d4ae50af.jpg";